module.exports = __webpack_public_path__ + "images/72ecf5ed90a0e02c2caa06fb9db8f7de-ab-mapCluster.png";